
export class ActiveDirectoryUser {
    displayName: string;
    id: string;
    mail: string;
    userPrincipalName: string;
  }
  